import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, Inbox, LogOut, ExternalLink, Phone, Quote, Image } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

const NAV = [
    { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true },
    { to: "/admin/quotes", label: "Demandes de devis", icon: Inbox },
    { to: "/admin/callbacks", label: "Demandes de rappel", icon: Phone },
    { to: "/admin/projects", label: "Réalisations", icon: Image },
    { to: "/admin/testimonials", label: "Témoignages", icon: Quote },
    { to: "/admin/blog", label: "Articles du blog", icon: FileText },
];

export default function AdminLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/admin/login", { replace: true });
    };

    return (
        <div className="min-h-screen bg-brand-bg flex" data-testid="admin-layout">
            <aside className="w-72 shrink-0 bg-brand-bgalt border-r border-brand-border flex flex-col">
                <div className="p-6 border-b border-brand-border">
                    <Logo />
                </div>
                <nav className="flex-1 p-4 space-y-1">
                    {NAV.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.end}
                            data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                                    isActive
                                        ? "bg-brand-sage text-brand-bg"
                                        : "text-brand-ink hover:bg-brand-sage/10"
                                }`
                            }
                        >
                            <item.icon size={16} />
                            {item.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="p-4 border-t border-brand-border space-y-2 text-sm">
                    <a
                        href="/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 px-4 py-2.5 text-brand-sageDark hover:text-brand-ink"
                        data-testid="admin-view-site"
                    >
                        <ExternalLink size={14} /> Voir le site
                    </a>
                    <div className="px-4 py-2 text-xs text-brand-sageDark border-t border-brand-border pt-3">
                        Connecté en tant que
                        <p className="text-brand-ink font-medium mt-0.5 truncate" data-testid="admin-current-user">{user?.email}</p>
                    </div>
                    <button
                        onClick={handleLogout}
                        data-testid="admin-logout-btn"
                        className="w-full flex items-center gap-3 px-4 py-2.5 text-brand-ink hover:bg-brand-sage/10"
                    >
                        <LogOut size={14} /> Déconnexion
                    </button>
                </div>
            </aside>
            <main className="flex-1 overflow-auto">
                <Outlet />
            </main>
        </div>
    );
}
